import axios from 'axios'
import ApiConfig from './ApiConfig'

export default class BaseRequest {

  constructor () {

  }

  builderHeader () {
    return {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
      'client-id': ApiConfig.client_id,
      'client-secret': ApiConfig.client_secret
    }
  }

  get (url, params = {}, version = ApiConfig.v1) {
    let config = this.builderHeader()
    return new Promise((resolve, reject) => {
      axios.get(ApiConfig.url + version + url, {headers: config})
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  put (url, data = {}, version = ApiConfig.v1) {
    let config = this.builderHeader()
    return new Promise((resolve, reject) => {
      axios
        .put(ApiConfig.url + version + url, data, {headers: config})
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  post (url, data = {}, version = ApiConfig.v1) {
    let config = this.builderHeader()
    return new Promise((resolve, reject) => {
      axios
        .post(ApiConfig.url + version + url, data, {headers: config})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  del (url, version = ApiConfig.v1) {
    let config = this.builderHeader()
    return new Promise((resolve, reject) => {
      axios
        .delete(ApiConfig.url + version + url, {headers: config})
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  _responseHandler (resolve, res) {
    return resolve(res.body.data)
  }

  _errorHandler (reject, err) {
    window.EventBus.$emit('EVENT_COMMON_ERROR', err)
    return reject(err)
  }

}



// WEBPACK FOOTER //
// ./src/communicate/BaseRequest.js